import React from "react";
import Icon from "~/src/components/icon";
import {
  LoadingIconWrapper,
  LoadingText,
  BlockWrapper
} from "./loading.styles";

export default function Loading(props) {
  const color = props.color || Icon.colors.WHITE;
  return (
    <BlockWrapper center={props.alignCenter}>
      <LoadingIconWrapper
        implementSafariLoadHack={props.implementSafariLoadHack}
        test={props.implementSafariLoadHack}
      >
        <Icon
          name={props.done ? Icon.names.DONE : Icon.names.LOADING}
          color={color}
        />
      </LoadingIconWrapper>
      <LoadingText hideText={props.hideText} color={color}>
        {props.done ? "Done!" : "Loading..."}
      </LoadingText>
    </BlockWrapper>
  );
}
